import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue, setStoredValue } from "../_helpers/storagehelper";

// create slice

const name = "master";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const masterActions = { ...slice.actions, ...extraActions };
export const masterReducer = slice.reducer;

// implementation

function createInitialState() {
  const facilityDropDown = getStoredValue("facilityDropDown");

  return {
    isPageReload: 0,
    islogReporttabKey: 0,
    isDashboardPage: false,
    ismsgFlagDisabled: false,
    stateDrpList: [],
    facilityDropDown: facilityDropDown ? facilityDropDown : [],
    loading: false,
    error: null,
    logHistoryLastName: [],
    logHistorFirstName: [],
    inmateFullNamewithId: [],
    GetPodList: [],
    downloadResponse: {},
    inmateAccessMenuList: [],
    publicUserFirstName: [],
    publicUserLastName: [],
    zipdata: [],
    loadNotificationAlert: {},
    applicationSettingsData: {},
  };
}

function createReducers() {
  return {
    clearStateDropdown,
    // removeCommonFaciityCode,
    clearinmateAccessMenuList,
    updateLocation,
    updatelogReporttabKey,
    UpdateisDashboardPage,
    UpdateisBacktoDashboard,
    updateismsgFlagDisabled,
    updateFirstName,
    clearInmateOptions,
  };

  function clearInmateOptions(state) {
    state.inmateFullNamewithId = [];
  }
  // inmateFullNamewithId
  function clearStateDropdown(state) {
    state.stateDrpList = [];
  }
  // function removeCommonFaciityCode(state) {
  //   state.commonFacilityCode = 0;
  // }

  function clearinmateAccessMenuList(state) {
    state.inmateAccessMenuList = [];
  }
  function updateLocation(state, action) {
    state.isPageReload = action.payload && action.payload;
  }
  function updatelogReporttabKey(state, action) {
    state.islogReporttabKey = action.payload && action.payload;
  }
  function UpdateisDashboardPage(state, action) {
    state.isDashboardPage = action.payload && action.payload;
  }
  function UpdateisBacktoDashboard(state, action) {
    state.isBacktoDashboard = action.payload && action.payload;
  }
  function updateismsgFlagDisabled(state, action) {
    state.ismsgFlagDisabled = action.payload && action.payload;
  }
  function updateFirstName(state, action) {
    state.logHistorFirstName = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;
  const downloadURL = `${process.env.REACT_APP_API_URL}/S3Activity/S3DownloadFile`;
  const ManagementMenuID = getStoredValue("user")?.ManagementUserID;
  const commonFacilityCode = getStoredValue("commonFacilityCode");

  return {
    GetStateList: GetStateList(),
    LoadFacilityDropDown: LoadFacilityDropDown(),
    GetInmateLastName: GetInmateLastName(),
    GetInmateFirstName: GetInmateFirstName(),
    GetInmateFullNameWithID: GetInmateFullNameWithID(),
    GetPODList: GetPODList(),
    DownLoadFiles: DownLoadFiles(),
    GetInmateMenuList: GetInmateMenuList(),
    GetPublicFirstName: GetPublicFirstName(),
    GetPublicLastName: GetPublicLastName(),
    DownLoadZipFiles: DownLoadZipFiles(),
    GetLoadNotificationAlert: GetLoadNotificationAlert(),
    GetPublicDefenderNotificationAlert: GetPublicDefenderNotificationAlert(),
    MaintenanceMode: MaintenanceMode(),
  };

  function GetStateList() {
    return createAsyncThunk(`${name}/GetStateList`, async () => {
      return await fetchWrapper.get(`${baseUrl}/Master/GetStateList`);
    });
  }

  // function LoadFacilityDropDown() {
  //   const facilityDropDown = getStoredValue("facilityDropDown");
  //   if (facilityDropDown) {
  //     return createAsyncThunk(`${name}/LoadFacilityDropDown`, async () => {
  //       return await fetchWrapper.get(`${baseUrl}/Master/GetFacilityList`);
  //     });
  //   }
  // }

  function LoadFacilityDropDown() {
    return createAsyncThunk(
      `${name}/LoadFacilityDropDown`,
      async (_, { getState }) => {
        const storedData = getStoredValue("facilityDropDown");

        //  If already cached → return it (NO API call)
        if (storedData && storedData.length > 0) {
          return storedData;
        }

        //  If not cached → call API
        const response = await fetchWrapper.get(
          `${baseUrl}/Master/GetFacilityList`
        );

        return response;
      }
    );
  }

  function GetPODList() {
    return createAsyncThunk(`${name}/GetPODList`, async (facilityID) => {
      return await fetchWrapper.get(
        `${baseUrl}/Master/GetPODList?facilityID=${facilityID}`
      );
    });
  }

  function GetInmateLastName() {
    return createAsyncThunk(
      `${name}/GetInmateLastName`,
      async ({ facilityID, FirstName }) => {
        // Check if FirstName is provided and construct the appropriate API URL
        const url = FirstName
          ? `${baseUrl}/Master/GetInmateLastName?facilityID=${facilityID}&firstName=${FirstName}`
          : `${baseUrl}/Master/GetInmateLastName?facilityID=${facilityID}`;

        // Fetch data from the constructed URL
        const response = await fetchWrapper.get(url);
        return response;
      }
    );
  }

  function GetInmateFirstName() {
    return createAsyncThunk(
      `${name}/GetInmateFirstName`,
      async ({ facilityID, LastName }) => {
        // Check if LastName is provided and construct the appropriate API URL
        const url = LastName
          ? `${baseUrl}/Master/GetInmateFirstName?facilityID=${facilityID}&lastName=${LastName}`
          : `${baseUrl}/Master/GetInmateFirstName?facilityID=${facilityID}`;

        // Fetch data from the constructed URL
        const response = await fetchWrapper.get(url);
        return response;
      }
    );
  }

  function GetInmateFullNameWithID() {
    return createAsyncThunk(
      `${name}/GetInmateFullNameWithID`,
      async (facilityID) => {
        return await fetchWrapper.get(
          `${baseUrl}/Master/GetInmateFullNameWithID?facilityID=${facilityID}`
        );
      }
    );
  }

  function DownLoadFiles() {
    return createAsyncThunk(
      `${name}/S3Activity`,
      async ({ filename, folderPath }, { rejectWithValue }) => {
        try {
          const response = await fetch(
            `${downloadURL}?filename=${filename}&folderPath=${folderPath}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/octet-stream",
              },
            }
          );

          if (!response.ok) {
            // Throw an error for non-OK responses
            throw new Error(`Failed to download file: ${response.statusText}`);
          }

          // Process the response as a Blob for binary data
          const blob = await response.blob();

          const fileName = filename || "downloaded_file";

          // Create a temporary link element to trigger the download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Optionally revoke the object URL after download to free memory
          window.URL.revokeObjectURL(url);

          return { success: true, fileName };
        } catch (error) {
          // Handle and return the failure response
          return rejectWithValue({ success: false, message: error.message });
        }
      }
    );
  }

  function GetInmateMenuList() {
    return createAsyncThunk(`${name}/GetInmateMenuList`, async (FacilityID) => {
      return await fetchWrapper.get(
        `${baseUrl}/Master/GetInmateMenuList?facilityID=${FacilityID}`
      );
    });
  }

  function GetPublicFirstName() {
    return createAsyncThunk(
      `${name}/GetPublicFirstName`,
      async ({ facilityID, lastName, inmatesId }) => {
        return await fetchWrapper.get(
          `${baseUrl}/Master/GetPublicFirstName?facilityID=${facilityID}&lastName=${lastName}&inmatesId=${inmatesId}`
        );
      }
    );
  }

  //GetPublicLastName
  function GetPublicLastName() {
    return createAsyncThunk(
      `${name}/GetPublicLastName`,
      async ({ facilityID, firstName, inmatesId }) => {
        return await fetchWrapper.get(
          `${baseUrl}/Master/GetPublicLastName?facilityID=${facilityID}&firstName=${firstName}&inmatesId=${inmatesId}`
        );
      }
    );
  }

  // function DownLoadZipFiles() {
  //   return createAsyncThunk(
  //     `${name}/DownLoadZipFiles`,
  //     async ({ filename, folderPath }, { rejectWithValue }) => {
  //       try {
  //         const response = await fetch(
  //           `${downloadURL}?filename=${filename}&folderPath=${folderPath}`,
  //           {
  //             method: "POST",
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //           }
  //         );

  //         if (!response.ok) {
  //           throw new Error(`Failed to fetch zip file: ${response.statusText}`);
  //         }

  //         // Process the response as a Blob (binary data)
  //         const blob = await response.blob();

  //         // Return the Blob object to store it in Redux
  //         return blob;
  //       } catch (error) {
  //         return rejectWithValue({ success: false, message: error.message });
  //       }
  //     }
  //   );
  // }

  function DownLoadZipFiles() {
    return createAsyncThunk(
      `${name}/DownLoadZipFiles`,
      async ({ filename, folderPath }, { rejectWithValue }) => {
        try {
          const response = await fetch(
            `${downloadURL}?filename=${filename}&folderPath=${folderPath}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch zip file: ${response.statusText}`);
          }

          // Process the response as a Blob (binary data)
          const blob = await response.blob();

          // Return the Blob object to store it in Redux
          return blob;
        } catch (error) {
          return rejectWithValue({ success: false, message: error.message });
        }
      }
    );
  }

  // function GetLoadNotificationAlert() {
  //   return createAsyncThunk(
  //     `${name}/GetNotificationCount`,
  //     async ({ ManagementUserID, FacilityID }) => {
  //       return await fetchWrapper.get(
  //         `${baseUrl}/ManagementUser/User/GetNotificationCount?ManagementUserID=${ManagementUserID ? ManagementUserID : ManagementMenuID }&FacilityID=${FacilityID ? FacilityID:commonFacilityCode}`
  //       );
  //     }
  //   );
  // }

  function GetLoadNotificationAlert() {
    return createAsyncThunk(
      `${name}/GetNotificationCount`,
      async ({ ManagementUserID, FacilityID }) => {

        // Determine final IDs with fallback
        const mgmtId = ManagementUserID || ManagementMenuID || 0;
        const facId = FacilityID || commonFacilityCode;

        // Stop API call if any value is missing
        if (!mgmtId) {
          return;
        }

        // API call
        const url = `${baseUrl}/ManagementUser/User/GetNotificationCount?ManagementUserID=${mgmtId}&FacilityID=${facId}`;

        return await fetchWrapper.get(url);
      }
    );
  }


  function GetPublicDefenderNotificationAlert() {
    return createAsyncThunk(
      `${name}/GetPublicDefenderNotificationAlert`,
      async ({ ManagementUserID, FacilityID }) => {
        return await fetchWrapper.get(
          `${baseUrl}/Common/GetPublicDefenderNotificationAlert?ManagementUserID=${ManagementUserID}&FacilityID=${FacilityID}`
        );
      }
    );
  }

  function MaintenanceMode() {
    return createAsyncThunk(`${name}/MaintenanceMode`, async (AppName) => {
      return await fetchWrapper.get(
        `${baseUrl}/Common/GetApplicationSettings?appName=${AppName}`
      );
    });
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.GetStateList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetStateList.fulfilled, (state, action) => {
      state.loading = false;
      state.stateDrpList = action.payload;
    })
    .addCase(extraActions.GetStateList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    // LoadFacilityDropDown
    .addCase(extraActions.LoadFacilityDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadFacilityDropDown.fulfilled, (state, action) => {
      state.loading = false;
      const facilityDropDown = action.payload;
      state.facilityDropDown = facilityDropDown;
      setStoredValue("facilityDropDown", facilityDropDown);
    })
    .addCase(extraActions.LoadFacilityDropDown.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    // GetInmateLastName
    .addCase(extraActions.GetInmateLastName.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetInmateLastName.fulfilled, (state, action) => {
      state.logHistoryLastName = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetInmateLastName.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //GetInmateFirstName
    .addCase(extraActions.GetInmateFirstName.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetInmateFirstName.fulfilled, (state, action) => {
      state.logHistorFirstName = action?.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetInmateFirstName.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //GetInmateFullName
    .addCase(extraActions.GetInmateFullNameWithID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetInmateFullNameWithID.fulfilled,
      (state, action) => {
        state.inmateFullNamewithId = action?.payload;
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(extraActions.GetInmateFullNameWithID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    // GetPODList
    .addCase(extraActions.GetPODList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPODList.fulfilled, (state, action) => {
      state.loading = false;
      const GetPodList = action.payload;
      state.GetPodList = GetPodList;
    })
    .addCase(extraActions.GetPODList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Common File Download
    .addCase(extraActions.DownLoadFiles.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.DownLoadFiles.fulfilled, (state, action) => {
      state.loading = false;
      state.downloadResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.DownLoadFiles.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Inmate Accessible Menu List
    .addCase(extraActions.GetInmateMenuList.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetInmateMenuList.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateAccessMenuList = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetInmateMenuList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Get Public User FirstName for Dropdown GetPublicFirstName
    .addCase(extraActions.GetPublicFirstName.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPublicFirstName.fulfilled, (state, action) => {
      state.loading = false;
      state.publicUserFirstName = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetPublicFirstName.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Get Public User LastName for Dropdown GetPublicLastName
    .addCase(extraActions.GetPublicLastName.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPublicLastName.fulfilled, (state, action) => {
      state.loading = false;
      state.publicUserLastName = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetPublicLastName.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //ZIP File DownLoadZipFiles
    // .addCase(extraActions.DownLoadZipFiles.pending, (state, action) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(extraActions.DownLoadZipFiles.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.zipdata = action.payload;
    //   state.error = null;
    // })
    // .addCase(extraActions.DownLoadZipFiles.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error;
    // });

    .addCase(extraActions.GetLoadNotificationAlert.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(
      extraActions.GetLoadNotificationAlert.fulfilled,
      (state, action) => {
        state.loading = false;
        state.loadNotificationAlert = action.payload;

        let storedMenuList = getStoredValue("menu_list");
        if (Array.isArray(storedMenuList) && Array.isArray(action.payload)) {
          const updatedMenuList = storedMenuList.map((menu) => {
            const notification = action.payload.find(
              (notif) => notif.ManagementMenuID === menu.ManagementMenuID
            );
            return notification
              ? { ...menu, NotificationCount: notification.NotificationCount }
              : menu;
          });

          setStoredValue("menu_list", updatedMenuList);
          state.menu_list = updatedMenuList;
        }
      }
    )
    .addCase(
      extraActions.GetLoadNotificationAlert.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    // Get Defender Notification
    .addCase(
      extraActions.GetPublicDefenderNotificationAlert.pending,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.isNoLoading) {
          state.loading = false;
        }
        else {
          state.loading = true;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetPublicDefenderNotificationAlert.fulfilled,
      (state, action) => {
        state.loading = false;
        state.loadNotificationAlert = action.payload;

        let storedMenuList = getStoredValue("menu_list");
        if (Array.isArray(storedMenuList) && Array.isArray(action.payload)) {
          const updatedMenuList = storedMenuList.map((menu) => {
            const notification = action.payload.find(
              (notif) => notif.ManagementMenuID === menu.ManagementMenuID
            );
            return notification
              ? { ...menu, NotificationCount: notification.NotificationCount }
              : menu;
          });

          setStoredValue("menu_list", updatedMenuList);
          state.menu_list = updatedMenuList;
        }
      }
    )
    .addCase(
      extraActions.GetPublicDefenderNotificationAlert.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //maintenance mode
    .addCase(extraActions.MaintenanceMode.pending, (state) => {
      // state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.MaintenanceMode.fulfilled, (state, action) => {
      // state.loading = false;
      state.applicationSettingsData = action.payload;
      state.error = null;
    })
    .addCase(extraActions.MaintenanceMode.rejected, (state, action) => {
      // state.loading = false;
      state.error = action.error;
    })

    .addCase(extraActions.DownLoadZipFiles.pending, (state) => {
      // Set loading to true when the download starts
      state.loading = true;
      state.error = null; // Clear any previous errors
    })
    .addCase(extraActions.DownLoadZipFiles.fulfilled, (state, action) => {
      // Set loading to false when the download is successful
      state.loading = false;
      state.zipdata = action.payload; // Store the downloaded data (if necessary)
      state.error = null; // Clear any errors
    })
    .addCase(extraActions.DownLoadZipFiles.rejected, (state, action) => {
      // Set loading to false when the download fails
      state.loading = false;
      state.error = action.error.message || "Failed to download file"; // Store the error message
    });
}
